// import { List, ListItem, ListItemText } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import {Card, CardContent,Button} from '@material-ui/core'
import logo from '../logo.png';
import "../styles/MemberPage.css"
import axios from 'axios';
import { useHistory } from 'react-router-dom'
import {ApiURL} from '../constants/ApiUrl'
import { Link } from "react-router-dom";
import {useSelector} from 'react-redux'

function MemberPage() {

    const [NewApp, setNewApp] = useState(0)
    const [MemberCount, setMemberCount] = useState(0)
    const [SortList, setSortList] = useState([])
    const history = useHistory();
    const user = useSelector(state => state.LoginReducer.user)

    useEffect(() => {
        // async function getNewApp(){
        //     const result = await axios.get(`${ApiURL}/api/get_member_stats`);
        //     if(result.data.data.length === 0)
        //         return;
        //     if(result.data.data.length > 1){
        //         if(result.data.data[0]._id === true){
        //             setMemberCount(result.data.data[0].total)
        //             setNewApp(result.data.data[1].total)
        //         }
        //         else{
        //             setMemberCount(result.data.data[1].total)
        //             setNewApp(result.data.data[0].total)
        //         }
        //     }
        //     else
        //     {
        //         if(result.data.data[0]._id === true){
        //             setMemberCount(result.data.data[0].total);
        //             setNewApp(0);
        //         }
        //         else
        //         {
        //             setMemberCount(0);
        //             setNewApp(result.data.data[0].total);
        //         }
        //     }
        //     const result2= await axios.post(`${ApiURL}/api/sortByStates`,{"group":"address.state"});
        //     setSortList(result2.data.data);
        // }
        // getNewApp();
    },[])
    return (
        <div className="adminDashboard">
            <h1>Welcome to NMO Membership Portal</h1>
            <img src={logo} className="memberlogo"/>
        </div>
    )
}

export default MemberPage
